import { render, staticRenderFns } from "./GirdImage.vue?vue&type=template&id=64c7c643&"
import script from "./GirdImage.vue?vue&type=script&lang=js&"
export * from "./GirdImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports